import { combineReducers } from 'redux'

import { reducer as apiv3 } from 'data/reducers/apiv3'
import { localeReducer as locale } from 'data/reducers/locale'

export const rootReducer = combineReducers({
  apiv3,
  locale
})
